/**
 * Wire parsers for API `booked_spot_names`: `MEMBER_BOOKED_SPOT_INDEX` (0) is the member's
 * spot; buddy/guest names follow. A blank member slot is preserved for buddy bookings.
 */
import { MEMBER_BOOKED_SPOT_INDEX } from './bookedSpotNames';
import { trimStringOrEmpty } from './spotName';

export { MEMBER_BOOKED_SPOT_INDEX };

export function normalizeWireBookedSpotNames(
  bookedSpotNameOrNames: string[] | string | undefined
): string[] {
  if (Array.isArray(bookedSpotNameOrNames)) {
    return bookedSpotNameOrNames.map((name) => trimStringOrEmpty(name));
  }
  const single = trimStringOrEmpty(bookedSpotNameOrNames);
  return single !== '' ? [single] : [];
}

export function getMemberBookedSpotNameFromWire(
  bookedSpotNameOrNames: string[] | string | undefined
): string {
  return normalizeWireBookedSpotNames(bookedSpotNameOrNames)[MEMBER_BOOKED_SPOT_INDEX] ?? '';
}

export function isMemberBookedSpotUnassignedFromWire(
  bookedSpotNameOrNames: string[] | string | undefined
): boolean {
  const names = normalizeWireBookedSpotNames(bookedSpotNameOrNames);
  if (names.length === 0) {
    return true;
  }

  const memberSpot = names[MEMBER_BOOKED_SPOT_INDEX];
  if (memberSpot == null) {
    return true;
  }

  return memberSpot.trim().length === 0;
}

export function getMemberVisibleBookedSpotNamesFromWire(
  bookedSpotNameOrNames: string[] | string | undefined,
  guestBookings?: number
): string[] {
  const names = normalizeWireBookedSpotNames(bookedSpotNameOrNames);
  if (guestBookings !== undefined && Number(guestBookings) <= 0) {
    return names.filter((name) => name !== '');
  }

  const memberSpot = names[MEMBER_BOOKED_SPOT_INDEX] ?? '';
  return memberSpot !== '' ? [memberSpot] : [];
}
